import person1 from "@assets/img/3-person.jpg";
import person3 from "@assets/img/1-person.jpg";
import person2 from "@assets/img/5-person.jpg";

export const testimonialsData = [
  {
    nameKey: "main.testimonials.maksym",
    avatar: person1,
  },
  {
    nameKey: "main.testimonials.maria",
    avatar: person2,
  },
  {
    nameKey: "main.testimonials.oleksandr",
    avatar: person3,
  },
];